module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ;  if (!locals.loggedIn) { 
    ; __append(" <li class=\"navbar-btn-wrapper\"><a href=\"/signin\" class=\"btn btn-default navbar-btn\">Log In</a></li> <li class=\"navbar-btn-wrapper\"><a href=\"/signup\" class=\"btn btn-red navbar-btn\">Sign Up</a></li> ")
    ;  } else { 
    ; __append(" ")
    ;  if (!locals.onDashboard) { 
    ; __append(" <li class=\"navbar-btn-wrapper\"><a class=\"btn btn-blue navbar-btn\" href=\"/account/shipments\">Dashboard</a></li> ")
    ;  } 
    ; __append(" <li class=\"dropdown acc-info\"> <a href=\"#\" class=\"dropdown-toggle\" data-toggle=\"dropdown\" role=\"button\" aria-haspopup=\"true\" aria-expanded=\"false\">")
    ; __append(escapeFn( locals.email ))
    ; __append(" <span class=\"caret\"></span></a> <ul class=\"dropdown-menu col-sm-12\"> <li><a href=\"#\" id=\"signout\">Sign Out</a></li> </ul> </li> ")
    ;  } 
    ; __append(" ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./templates/navbar.ejs
// module id = 855
// module chunks = 1